import React from 'react';
import { useTranslation } from 'react-i18next';

import type { IPerson } from '@feathr/blackbox';
import { colors } from '@feathr/components';
import { cssVar, moment } from '@feathr/hooks';

import anonBird1 from '@feathr/extender/images/anonbird1.png';

const { getLuma, shade } = colors;

interface IProps {
  person: IPerson;
}

export default function PersonIcon({ person }: IProps) {
  const { t } = useTranslation();

  const now = moment.utc();
  const lastSeenMoment = moment.utc(person.date_last_seen, moment.ISO_8601);
  const isActive = now.diff(lastSeenMoment, 'hours') < 24;
  const isNotAnonymous = person.name && person.name.trim().length !== 0;
  const placeholder = person.placeholder || {
    name: t('Anonymous'),
    color_hex: cssVar('--color-text-body'),
    color_name: t('Gray'),
    bird: t('Pigeon'),
  };
  const name = isNotAnonymous ? person.name! : placeholder.name || t('Anonymous')!;
  const splitName = name.split(' ');
  const initials =
    splitName.length > 1
      ? `${splitName[0].charAt(0)}${splitName[1].charAt(0)}`
      : splitName[0].charAt(0);
  const avatarColor = placeholder.color_hex || cssVar('--color-text-body');
  return (
    <div
      style={{
        minWidth: '42px',
        width: '42px',
        height: '42px',
        borderRadius: '50%',
        backgroundColor: isActive ? cssVar('--color-brand-green') : cssVar('--color-disabled'),
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        marginRight: '5px',
      }}
    >
      <div
        style={{
          width: '36px',
          height: '36px',
          borderRadius: '50%',
          backgroundColor: getLuma(avatarColor) > 80 ? shade(avatarColor, -0.2) : avatarColor,
          backgroundImage: isNotAnonymous ? undefined : `url("${anonBird1}")`,
          backgroundPosition: 'center',
          backgroundRepeat: 'no-repeat',
          backgroundSize: 'contain',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
        }}
      >
        {isNotAnonymous && (
          <div
            style={{
              color: cssVar('--color-text-body-inverted'),
              fontWeight: 600,
              fontSize: '18px',
            }}
          >
            {initials.toUpperCase()}
          </div>
        )}
      </div>
    </div>
  );
}
